import React from "react";
import { Link } from "react-router-dom";
import styles from "./header.module.scss"
import adneonHorizontalLogo from "images/logo_adneonHorizontal.png"
import { IconButton, Button, Menu, MenuItem } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';

const Header = (props) => {
  const [phoneMenu, setPhoneMenu] = React.useState(null);
  const [about, setAbout] = React.useState(null);
  const [language, setLanguage] = React.useState(null);
  const phoneMenuOpen = Boolean(phoneMenu);
  const aboutOpen = Boolean(about);
  const languageOpen = Boolean(language);
  const handlePhoneMenuClick = (event) => {
    setPhoneMenu(event.currentTarget);
  };
  const handlePhoneMenuClose = () => {
    setPhoneMenu(null);
  };
  const handleAboutClick = (event) => {
    setAbout(event.currentTarget);
  };
  const handleAboutClose = () => {
    setAbout(null);
  };
  const handleLanguageClick = (event) => {
    setLanguage(event.currentTarget);
  };
  const handleLanguageClose = () => {
    setLanguage(null);
  };
  const handleLanguage = () => {
    props.searchParams.get("lang") === 'en' ? props.changeSearchParams() : props.changeSearchParams('en')
    setLanguage(null);
  };
  const returnLinkRender = () => {
    switch (props.searchParams.get("lang")) {
      case 'en':
        return `/?lang=en`
      default:
        return '/'
    }
  }
  const renderLanguageSelect = () => {
    return (
      <div className={styles.language}>
        <Button
          id="language-button"
          aria-controls={languageOpen ? 'language-menu' : undefined}
          aria-haspopup="true"
          aria-expanded={languageOpen ? 'true' : undefined}
          onClick={handleLanguageClick}
        >
          {props.searchParams.get("lang") === 'en' ? '🇺🇸' : '🇹🇼'}
        </Button>
        <Menu
          id="language-menu"
          anchorEl={language}
          open={languageOpen}
          onClose={handleLanguageClose}
          MenuListProps={{
            'aria-labelledby': 'language-button',
          }}
        >
          <MenuItem onClick={handleLanguage}>{props.searchParams.get("lang") === 'en' ? '🇹🇼' : '🇺🇸'}</MenuItem>
        </Menu>
      </div>
    )
  }
  return (
    <header>
      <div className={styles.leftContainer}>
        <Link to={returnLinkRender()}>
          <img alt='' src={adneonHorizontalLogo} />
        </Link>
        <div>
          <Link to={returnLinkRender()}>
            <span>Rich Media Gallery</span>
          </Link>
        </div>
      </div>
      <div className={styles.rightContainer}>
        <div className={styles.phone}>
          <IconButton
            size="large"
            edge="start"
            color="inherit"
            aria-label="menu"
            sx={{ mr: 2 }}
          >
            <Button
              id="phoneMenu-button"
              aria-controls={phoneMenuOpen ? 'phoneMenu' : undefined}
              aria-haspopup="true"
              aria-expanded={phoneMenuOpen ? 'true' : undefined}
              onClick={handlePhoneMenuClick}
            >
              <MenuIcon />
            </Button>
            <Menu
              id="phoneMenu-menu"
              anchorEl={phoneMenu}
              open={phoneMenuOpen}
              onClose={handlePhoneMenuClose}
              MenuListProps={{
                'aria-labelledby': 'phoneMenu-button',
              }}
            >
              <MenuItem>
                <div className={styles.about}>
                  <Button
                    id="about-button"
                    aria-controls={aboutOpen ? 'about-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={aboutOpen ? 'true' : undefined}
                    onClick={handleAboutClick}
                    sx={{ color: 'white' }}
                  >
                    關於我們
                  </Button>
                </div>
              </MenuItem>
              <MenuItem>
                <div className={styles.language}>
                  <Button
                    id="language-button"
                    aria-controls={languageOpen ? 'language-menu' : undefined}
                    aria-haspopup="true"
                    aria-expanded={languageOpen ? 'true' : undefined}
                    onClick={handleLanguageClick}
                  >
                    {props.searchParams.get("lang") === 'en' ? '🇺🇸' : '🇹🇼'}
                  </Button>
                </div>
              </MenuItem>

            </Menu>
          </IconButton>
        </div>
        <div className={styles.desktop}>
          <div className={styles.about}>
            <Button
              id="about-button"
              aria-controls={aboutOpen ? 'about-menu' : undefined}
              aria-haspopup="true"
              aria-expanded={aboutOpen ? 'true' : undefined}
              onClick={handleAboutClick}
            >
              {props.searchParams.get("lang") === 'en' ? 'About Us' : '關於我們'}
            </Button>
            <Menu
              id="about-menu"
              anchorEl={about}
              open={aboutOpen}
              onClose={handleAboutClose}
              MenuListProps={{
                'aria-labelledby': 'about-button',
              }}
            >
              <a href="https://www.tenmax.io/" target="_blank" rel="noreferrer">
                <MenuItem onClick={handleAboutClose}>TenMax</MenuItem>
              </a>
              <a href="https://www.adneon.com.tw/" target="_blank" rel="noreferrer">
                <MenuItem onClick={handleAboutClose}>AdNeon</MenuItem>
              </a>
            </Menu>
          </div>
          <div>
            {renderLanguageSelect()}
          </div>
        </div>
      </div>
    </header>
  )
}
export default Header